import { useEffect, useState } from "react";
import { useTranslate } from "ra-core";

import { DEALS_ENABLED } from "@/components/atomic-crm/consts";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

import {
  NO_AREAS,
  readVoltRoles,
  voltAreas,
  type VoltAreas,
} from "./voltAreas";
import { voltNavGroups } from "./voltNavGroups";

/** Areas from the current session token, updated on refresh and sign-in. */
export const useVoltAreas = (): VoltAreas => {
  const [areas, setAreas] = useState<VoltAreas>(NO_AREAS);
  useEffect(() => {
    // INITIAL_SESSION fires right after subscribing, so no getSession() call is needed.
    const { data } = getSupabaseClient().auth.onAuthStateChange(
      (_event, session) => {
        setAreas(voltAreas(readVoltRoles(session?.access_token)));
      },
    );
    return () => data.subscription.unsubscribe();
  }, []);
  return areas;
};

export const useVoltNavGroups = (areas: VoltAreas) => {
  const translate = useTranslate();
  return voltNavGroups(
    areas,
    {
      dashboard: translate("ra.page.dashboard"),
      contacts: translate("resources.contacts.name", { smart_count: 2 }),
      companies: translate("resources.companies.name", { smart_count: 2 }),
      deals: translate("resources.deals.name", { smart_count: 2 }),
      attendance: translate("crm.attendance.menu"),
      fundingList: translate("crm.funding_list.menu"),
      general: translate("crm.nav.general"),
    },
    DEALS_ENABLED,
  );
};
